import Button from '@cobliteam/colib-ui/Button';
import { Dialog, DialogBody, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@cobliteam/colib-ui/Dialog';
import Icon from '@cobliteam/colib-ui/Icon';
import Typography from '@cobliteam/colib-ui/Typography';
import { useTranslation } from '@cobliteam/i18n';
import useContractRenewalVisibility from './useContractRenewalVisibility';

const DialogContractRenewal = () => {
  const { t } = useTranslation('contract-renewal');
  const { shouldShow, onClose } = useContractRenewalVisibility();
  if (!shouldShow) return null;
  return (
    <Dialog open>
      <DialogContent size='md' showCloseButton={false}>
        <DialogHeader className='flex-row items-center justify-between'>
          <DialogTitle>{t('dialog.title')}</DialogTitle>
          <DialogDescription className='sr-only'>{t('dialog.description')}</DialogDescription>
        </DialogHeader>
        <DialogBody>
          <Typography variant='body' className='gap-1 break-words text-foreground'>
            {t('dialog.description')}
          </Typography>
        </DialogBody>
        <DialogFooter className='flex items-center justify-between gap-2'>
          <Button variant='ghost' onClick={onClose}>
            {t('dialog.close_for_now')}
          </Button>
          <div className='flex gap-2'>
            <Button variant='outline' render={<div className='flex items-center gap-2' />}>
              <Icon size='sm' name='phone' />
              <a href='tel:+551148102200'>{t('dialog.phone_call')}</a>
            </Button>
            <Button render={<div className='flex items-center gap-2' />}>
              <Icon size='sm' name='cb-whatsapp' />
              <a href='https://wa.me/551148102200' target='_blank' rel='noopener noreferrer'>
                {t('dialog.whatsapp_contact')}
              </a>
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
export default DialogContractRenewal;
